import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { CustomerKbaAnswerData, CustomerKbaConversation, IdentityVerificationResultStateHelper, IdentityVerificationStatus, MessageService, SsoAccountData } from 'common';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { KbaFormFacade } from './kba.form.facade';
import { KbaData } from './model/kba-form.model';
import { catchError } from 'rxjs/operators';
import { EMPTY } from 'rxjs';

@UntilDestroy()
@Component({
    selector: 'ifm-kba-form',
    templateUrl: './kba-form.component.html',
    styleUrls: ['./kba-form.component.scss'],
    providers: [KbaFormFacade],
    standalone: false
})
export class KbaFormComponent implements OnInit {
  @Output() verified: EventEmitter<SsoAccountData> = new EventEmitter<SsoAccountData>();

  kbaConversation: CustomerKbaConversation;
  submitEnabled = true;
  form: UntypedFormGroup;

  constructor(
    private router: Router,
    private messageService: MessageService,
    private facade: KbaFormFacade,
  ) { }

  ngOnInit(): void {
    this.facade
      .initData()
      .pipe(untilDestroyed(this), catchError((err) => {
        this.messageService.error(err);
        return EMPTY;
      }))
      .subscribe((result) => {
        this.initData(result);
      });
  }

  private initData(kbaConversation: CustomerKbaConversation): void {
    this.kbaConversation = kbaConversation;
    this.form = this.facade.initForm(kbaConversation);
  }

  submit(): void {
    if (!this.form.valid) {
      return;
    }

    this.facade.save(this.form.value as KbaData)
      .subscribe({
        next: (results) => this.submitSuccess(results.results, results.currentSsoAccount),
        error: this.submitError.bind(this)
      });
  }

  private submitError(response: any): void {
    if (response.status === 400) {
      const errorMessage = response.error?.error_description || response.error;
      this.submitEnabled = false;
      IdentityVerificationResultStateHelper.set({ message: errorMessage });
      this.router.navigate(['account', 'setup', 'verify-identity-result'], {
        replaceUrl: true,
      });
    }
    else {
      this.messageService.error(response.error);
    }
  }

  private submitSuccess(results: CustomerKbaAnswerData, currentAccount: SsoAccountData): void {
    if (results.status === IdentityVerificationStatus.Success) {
      this.submitEnabled = false;
      this.verified.emit(currentAccount);
    } else if (results.status === IdentityVerificationStatus.Pending) {
      this.kbaConversation = results.questions;
      this.form = this.facade.initForm(this.kbaConversation);
    }
  }
}
